import axios from 'axios';
import { API } from 'aws-amplify';
import { getLatestJwtToken } from './amplify-auth';
import { apiKey } from '../constants';
import { RoutePoint } from 'views/Restaurant/RouteConfirmation';

const getOptions = async () => {
  return {
    headers: {
      'x-api-key': apiKey,
      Authorization: `Bearer ${await getLatestJwtToken()}`
    }
  };
};

export const fetchAirspace = async (selectedCellId: number) => {
  let lat = 53.269837;
  let lng = -8.931032;
  if (selectedCellId === 8) {
    lat = 33.09246542236036;
    lng = -97.2481172359254;
  }

  return axios.get(
    `${process.env.REACT_APP_MANNA_CORE_API_HOST}/airspace/view?latitude=${lat}&longitude=${lng}`,
    await getOptions()
  );
};

const createFeatureCollectionWithCoords = (routeCoords: any[], properties: Record<string, string>) => {
  const coords = (routeCoords as any)[0]?.coordinates
    ? (routeCoords as any).map((point: any) => point.coordinates)
    : routeCoords;

  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: properties,
        geometry: {
          type: 'LineString',
          coordinates: coords
        }
      }
    ]
  } as any;
};

const generateAbitraryLineStringProperties = (routeCoords: RoutePoint[]) => {
  const properties: Record<string, string> = {};
  for (let i = 0; i < routeCoords.length; i++) {
    const type = (routeCoords[i] as any).type;
    properties[i] = `index=${i},type=${type},relativeAltitude=66,speed=16,`;
  }
  return properties;
};

const createRouteFeatureCollectionFromCoordsAndProperties = (
  routeCoords: RoutePoint[],
  properties?: Record<string, string>
) => {
  let props: Record<string, string>;
  const reversedRouteCoords = routeCoords.map(point => {
    return [point.coordinates[1], point.coordinates[0]];
  });
  if (properties) {
    props = properties;
  } else {
    props = generateAbitraryLineStringProperties(routeCoords);
  }
  return createFeatureCollectionWithCoords(reversedRouteCoords as any[], props);
};

export const updateRoute = (orderId: string, missionId: string, routeCoords: RoutePoint[]) => {
  const routeFeatureCollection = createRouteFeatureCollectionFromCoordsAndProperties(
    routeCoords,
    null as any
  );
  return API.post(
    'api',
    `/mission/route/update/?orderId=${orderId}&missionId=${missionId}&flightapi=1.6.3`,
    {
      body: routeFeatureCollection
    }
  );
};

export const reserveRoute = (orderId: string, missionId: string) => {
  return API.post(
    'api',
    `/mission/route/reserve/?orderId=${orderId}&missionId=${missionId}&flightapi=1.6.3`,
    {}
  );
};


export const deleteMissionAirspace = (orderId: string, missionId: string) => {
  return API.post(
    'api',
    `/mission/route/remove/?orderId=${orderId}&missionId=${missionId}&flightapi=1.6.3`,
    {}
  );
};


